// extracted by mini-css-extract-plugin
export default {"container":"VideoGrid_container__0j736"};